<template>
  <div
    class="owal-list-section__header"
    @click="clicked"
  >
    {{ title }}
    <owal-list-row-accessory
      :class="`${this.collapsed ? 'owal-list__accessory_collapsed' : 'owal-list__accessory'}`"
    />
  </div>
</template>

<script>

import OwalListRowAccessory from './OwalListRowAccessory'
export default {
  name: 'OwalListSectionHeader',
  components: {
    OwalListRowAccessory,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    collapsible: {
      type: Boolean,
      default: false,
    },
    didCollapseCallback: {
      type: Function,
      default: undefined,
    },
  },
  data () {
    return {
      collapsed: false,
    }
  },
  methods: {
    clicked () {
      this.collapsed = !this.collapsed
      this.$emit('click', this.collapsed)
    },
  },
}
</script>

<style scoped>
.owal-list-section__header {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  background: #475669;
  color: #EFF2F7;
  font-family: 'Lato', 'Roboto', 'Avenir', 'Helvetica', sans;
  font-weight: bold;
  padding: 0.75rem;
  cursor: pointer;
}

.owal-list__accessory {
  transform: rotate(90deg);
}

.owal-list__accessory,
.owal-list__accessory_collapsed {
  transition: transform 200ms linear;
}
</style>
